import { Alert as AntAlert } from "antd";
import { Button as CloseButton, Col, Row, Typography } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { CloseSection } from "../../components/Popup/Popup.styles";
import { ErrorMessage } from "views/components/Message";
import {
	FooterModalWrapper,
	ButtonWrapper,
} from "../../screens/LoginModal/styles";
import { LoginModal as Modal } from "../../components/Popup/LoginModal";
import { Spacer } from "views/components/common/Spacer";
import { Wrapper } from "../../screens/LoginModal/styles";
import { sessionId, getSessionId } from "lib/sessionIdTemporaryUser";
import { useTemporaryUser } from "hooks/useTemporaryUser";
import Input from "views/components/common/Input/Input";
import Recaptcha from "react-recaptcha";
import Styled from "styled-components";
import config from "config";
import { ModalButton } from "../../../components/ModalButton";
import { useHistory, useParams } from "react-router-dom";
import React, { useEffect, useState, useRef } from "reactn";
import { pathOr } from "lib/functions";
import format, { validate } from "lib/rut";
import ReCAPTCHA from "react-google-recaptcha";
import { useRecaptcha } from "hooks/useRecaptcha";
import { validateRut, validateDni } from "lib/helpers/documents";

const { recaptchaKey } = config;

const { Text } = Typography;

export const TicketWihtoutLogin = ({
	setShowModalTemporary,
	showInputRut,
	visible,
	onClose,
	ticketAction,
	isActive,
	setActiveSignUp,
	isDni,
	isRut,
	pickTicket,
	ticketFormsData,
	line,
}) => {
	const [inputs, setInputs] = useState({});
	const params = useParams();
	const [buttonVisible, setButtonVisible] = useState(true);
	const [captchaToken, setCaptchaToken] = useState(null);
	const [errorLabel, setErrorLabel] = useState(false);
	const officeSlug = pathOr(false, ["officeslug"], params);
	const [login, success, loading, error] = useTemporaryUser(onClose);
	const [disabledButton, setDisabledButton] = useState(false);
	const history = useHistory();
	const attentionType = isDni ? "dni" : "rut";

	const questions = pathOr([], ["questions"], ticketFormsData);

	const onChangeInputs = ({ input, value }) => {
		setInputs((i) => ({ ...i, [input]: value }));

		if (input === "rut" && !validateRut(value)) {
			setErrorLabel("Ingrese un rut válido");
			return;
		}

		if (input === "dni" && !validateDni(value)) {
			setErrorLabel("Ingrese un dni válido");
			return;
		}
		setErrorLabel(false);
		setDisabledButton(false);
		/* 	return isDni ? setTemporaryDni(value) : setTemporaryRut(value);
		setDisabledButton(false);
		setErrorLabel("");
 */
	};
	const refCaptcha = useRef();
	const { onSubmitWithReCAPTCHA, loading: reCaptchaLoading } = useRecaptcha(
		login,
		refCaptcha
	);

	useEffect(() => {
		if (success) {
			// return ticketAction();
		}
	}, [success]);

	useEffect(() => {
		if (success) {
			setShowModalTemporary(true);
		}
	}, [success]);

	const handlerAlreadyRegistered = () => {
		isActive();
		onClose();
	};
	const handlerLogin = () => {
		setActiveSignUp();
		onClose();
	};

	useEffect(() => {
		getSessionId(officeSlug).then((res) => {
			const string = res.toString();
			setInputs((i) => ({ ...i, ["sessionId"]: string }));
		});
	}, []);

	const handleClick = () => {
		if (questions.length > 0) {
			return onSubmitWithReCAPTCHA(inputs).then(() =>
				setTimeout(
					() =>
						history.push(
							`/ticket-forms/${officeSlug}/${line.slug}`
						),
					1000
				)
			);
		}

		onSubmitWithReCAPTCHA(inputs, null, pickTicket).then((token) => {
			onClose();
		});
	};

	return (
		<Modal visible={visible} size={"small"} onCancel={onClose}>
			<CloseSection>
				{/* <CloseButton
					onClick={onClose}
					type="dashed"
					shape="circle"
					icon={
						<CloseOutlined
							style={{ fontSize: "26px", color: "#aaa" }}
						/>
					}
				></CloseButton> */}
			</CloseSection>
			<Wrapper>
				{showInputRut ? (
					<>
						<TextCol>
							<Text className="title__login-modal">
								Ingresar sin registro
							</Text>
							{error && (
								<AntAlert
									description={error.message}
									type="error"
									showIcon
								/>
							)}
							<Spacer rows={1} />
							<Text
								className="modal__text-welcome"
								type="secondary"
							>
								Esta sucursal exige identificación para
								continuar.
							</Text>
						</TextCol>
						<div className="button__container">
							<Input
								type={attentionType}
								name={attentionType}
								label={attentionType.toUpperCase()}
								isRut={isRut}
								onChange={onChangeInputs}
							></Input>
							{errorLabel && (
								<span className={"error__label-temporary"}>
									{errorLabel}
								</span>
							)}
						</div>

						<Spacer rows={1} />
						<ReCAPTCHA
							hl={"es-419"}
							ref={refCaptcha}
							sitekey={recaptchaKey}
							size={"invisible"}
						/>
						{/* <GoogleReCaptcha onVerify={verifyCallback} /> */}
						{/* <Recaptcha
							sitekey={recaptchaKey}
							// onloadCallback={callback}
							verifyCallback={verifyCallback}
						/> */}
						<Spacer rows={1} />
						{buttonVisible && (
							<ButtonWrapper>
								{/* <ModalButton
									onClick={() => login(inputs, captchaToken)}
									loading={loading}
									type={"primary"}
									label="Sacar ticket"
								/> */}
								<ModalButton
									onClick={handleClick}
									loading={loading || reCaptchaLoading}
									type={"primary"}
									label="Sacar ticket"
									disabled={
										loading || errorLabel || disabledButton
									}
								/>
							</ButtonWrapper>
						)}
					</>
				) : (
					<>
						<TextCol>
							<Text className="title__login-modal">
								Ingresar sin registro
							</Text>
						</TextCol>
						<ReCAPTCHA
							hl={"es-419"}
							ref={refCaptcha}
							sitekey={recaptchaKey}
							size={"invisible"}
						/>
						{/* <Recaptcha
							sitekey={recaptchaKey}
							// onloadCallback={callback}
							// verifyCallback={verifyCallback}
						/> */}
						<Spacer rows={1} />
						{buttonVisible && (
							<ButtonWrapper>
								<ModalButton
									onClick={handleClick}
									loading={loading || reCaptchaLoading}
									type={"primary"}
									label="Sacar ticket"
									disabled={errorLabel || disabledButton}
								/>
								{/* <ModalButton
									onClick={() => login(inputs, captchaToken)}
									loading={loading}
									type={"primary"}
									label="Sacar ticket"
								/> */}
							</ButtonWrapper>
						)}
						<Spacer rows={1} />
						{error && (
							<AntAlert
								style={{ textAlign: "left" }}
								description={error.message}
								type="error"
								showIcon
							/>
						)}
					</>
				)}
				<Spacer rows={2} />
				<FooterModalWrapper>
					<div>
						<span>
							Si no estas registrado,{" "}
							<a
								style={{
									color: "#145AB4",
									fontWeight: "bold",
									textDecoration: "underline",
								}}
								onClick={handlerLogin}
							>
								crea tu cuenta
							</a>{" "}
							o{" "}
							<a
								style={{
									color: "#145AB4",
									fontWeight: "bold",
									textDecoration: "underline",
								}}
								onClick={handlerAlreadyRegistered}
							>
								inicia sesión
							</a>{" "}
							para continuar
						</span>
					</div>
				</FooterModalWrapper>
			</Wrapper>
		</Modal>
	);
};

const TextCol = Styled(Col)`
	display: flex;
	flex-direction:column;
	justify-content: center;
	align-items: center;
	text-align: center;
	margin-bottom: 32px;
	.title__login-modal {
		font-weight: 800;
		font-size:16px;
		color:#145AB4
	}
`;
